import { Container } from "@/components/ui/container";
import S from "./index.module.scss";
import { ImageDTO, PropertyDetail } from "@/api/generated-api";
import Picture from "@/components/ui/picture";

interface TechnicalPropertiesProps {
  properties: PropertyDetail[];
  properties_image: ImageDTO;
}

const TechnicalProperties = ({ properties, properties_image }: TechnicalPropertiesProps) => {
  return (
    <section className={S.properties}>
      <Container className={S.container}>
        <div className={S.visual}>
          <div className={S.visualMedia}>
            <Picture image={properties_image} className={S.watchImage} />
          </div>

          <h2 className={S.title}>
            <span>Технические</span>
            <span>характеристики</span>
          </h2>
        </div>
        <div className={S.grid}>
          {properties.map(property => (
            <div key={property.title} className={S.propertyItem}>
              <p className={S.propertyLabel}>{property.title}</p>
              <p className={S.propertyValue}>{property.value}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default TechnicalProperties;
